function docReady(fn) {
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

let added = false;

docReady(function () {
  var cartBtn = document.getElementById("fls-cart-btn");
  cartBtn.addEventListener("click", onSubmitHandler);
});

function pupulateCart(cart) {
  const sidecart = document.getElementById("main-cart-items-2");
  const sidecartWr = document.querySelector(".fls-sidecart__wrapper");
  const subtotalPrice = document.querySelector(
    ".fls-cart-aside__subtotal-price"
  );
  const totalPrice = document.querySelector(".fls-cart-aside__total-price");
  const cartQnt = document.querySelectorAll(".icon--carfull-counter");
  if (cart.item_count > 0) {
    sidecartWr.classList.remove("cart-is-empty");
    sidecart.innerHTML = "";

    subtotalPrice.innerHTML = Shopify.formatMoney(
      cart.items_subtotal_price,
      shopCurrencySymbol + "{{ amount_with_comma_separator }}"
    );
    totalPrice.innerHTML = Shopify.formatMoney(
      cart.total_price,
      shopCurrencySymbol + "{{ amount_with_comma_separator }}"
    );

    const cartIcons = document.querySelectorAll(".svg-icon--cart");
    cartIcons.forEach(function (cartIcon) {
      cartIcon.classList.add("svg-icon--cartfull");
    });
    document
      .querySelector(".fls-cart-grid__main")
      .classList.remove("cart-is-empty");
    document.querySelectorAll(".icon--carfull-counter").forEach((icon) => {
      icon.innerHTML = +cart.item_count;
    });
  }

  for (let i = 0; i < cart.items.length; i++) {
    const itemOptions = document.createElement("div");
    itemOptions.className = "fls-cart__item-options";
    for (let j = 0; j < cart.items[i].options_with_values.length; j++) {
      var optionLine = document.createElement("div");
      optionLine.className = "fls-cart__item-option";
      optionLine.innerHTML =
        cart.items[i].options_with_values[j].name +
        ": " +
        cart.items[i].options_with_values[j].value;

      itemOptions.append(optionLine);
    }

    let itemIndex = i + 1;
    let itemPrice = String(cart.items[i].price);
    let finalLinePrice = String(cart.items[i].final_line_price);
    let itemDiscount;
    if (cart.items[i].compare_at_price) {
      itemDiscount =
        `<span style="font-size:12px">` +
        String(100 - (itemPrice / cart.items[i].compare_at_price) * 100) +
        `% - OFF </span>`;
    }
    console.log(itemDiscount);
    const originalPrice =
      cart.items[i].compare_at_price * cart.items[i].quantity;

    const originalPriceFull = !!originalPrice
      ? Shopify.formatMoney(
          originalPrice,
          shopCurrencySymbol + "{{ amount_with_comma_separator }}"
        )
      : "";
    const itemPriceClasses = !!originalPrice
      ? "item-price item-price--new"
      : "item-price";

    const Prezzo =
      itemDiscount == undefined
        ? Shopify.formatMoney(
            finalLinePrice,
            shopCurrencySymbol + "{{ amount_with_comma_separator }}"
          )
        : itemDiscount +
          Shopify.formatMoney(
            finalLinePrice,
            shopCurrencySymbol + "{{ amount_with_comma_separator }}"
          );

    const item = document.createElement("div");
    item.className = "fls-cart__item";
    item.setAttribute("data-index", itemIndex);
    item.setAttribute("data-itemid", cart.items[i].id);
    item.innerHTML =
      `<div class="fls-cart__image-wrapper">
                <a href="` +
      cart.items[i].image +
      `" class="fls-cart__image-link" aria-hidden="true" tabindex="-1"> </a>
                <img class="fls-cart__image"
                src="` +
      cart.items[i].image +
      `"
                loading="lazy"
                width="150"
                height="150"
                >
            </div>
        
            <div class="fls-cart__item-meta">
                <a href="` +
      cart.items[i].url +
      `" class="fls-cart__item-title">` +
      cart.items[i].product_title +
      `</a>

                <div class="fls-sidecart__item-options">
                    <div class="fls-cart__item-option">
                        Code: ` +
      cart.items[i].sku +
      `
                    </div>` +
      itemOptions.innerHTML +
      `<div class="fls-cart__item-option fls-price">
                        Price: ` +
      Shopify.formatMoney(
        itemPrice,
        shopCurrencySymbol + "{{ amount_with_comma_separator }}"
      ) +
      `
                    </div>
                </div>
            </div>
            
            <div class="fls-cart__item-actions">
                <cart-remove-button class="fls-cart__remove fls-cart__remove-side" id="Remove-` +
      itemIndex +
      `" >
                    <a href="" class="svg-icon fls-cart__remove-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23" fill="none">
                            <rect x="3" y="5.38721" width="14" height="17" stroke="black"/>
                            <rect x="0.5" y="-0.5" width="18" height="3" transform="matrix(1 0 0 -1 0.5 4.88721)" stroke="black"/>
                            <rect x="0.5" y="-0.5" width="6" height="1" transform="matrix(1 0 0 -1 6.5 1.88721)" stroke="black"/>
                            <line x1="10" y1="7.88721" x2="10" y2="20.8872" stroke="black"/>
                            <line x1="14" y1="7.88721" x2="14" y2="20.8872" stroke="black"/>
                            <line x1="6" y1="7.88721" x2="6" y2="20.8872" stroke="black"/>
                        </svg>
                    </a>
                </cart-remove-button>

                <div class="fls-sidecart__item-actions-bottom">
                    <div class="fls-cart__quantity">
                        <label class="fls-cart__quantity-label" for="Quantity-` +
      itemIndex +
      `">
                            Quantity
                        </label>

                        <quantity-input class="fls-cart__quantity-input-wr" data-itemid="` +
      cart.items[i].id +
      `">
                            <button class="fls-cart__quantity-btn no-js-hidden" name="minus" type="button" >
                                    - 
                            </button>
                            <input class="fls-cart__quantity-input"
                            disabled
                                type="number"
                                name="updates[]"
                                value="` +
      cart.items[i].quantity +
      `"
                                min="0"
                                id="Quantity-` +
      itemIndex +
      `"
                                data-index="` +
      itemIndex +
      `"
                            >
                            <button class="fls-cart__quantity-btn no-js-hidden" name="plus" type="button" >
                                    + 
                            </button>
                        </quantity-input>
                    </div>

                    <div class="fls-cart__totals">
                        <div class="">
                           
                            <div class="item-price--old" data-itemid="` +
      cart.items[i].id +
      `" data-original-price="` +
      cart.items[i].compare_at_price +
      `"> ` +
      originalPriceFull +
      ` </div> <div class="` +
      itemPriceClasses +
      `" data-itemid="` +
      cart.items[i].id +
      `" data-price="` +
      cart.items[i].price +
      `" >` +
      Prezzo +
      `                                
                            </div>

                        </div>
                    </div>
                </div>
            </div>`;

    sidecart.append(item);
  }
}

function onSubmitHandler(evt) {
  evt.preventDefault();
  const sidecartInput = document.getElementById("fls-header__cart");
  const submitButton = document.querySelector('[for="add-to-cart"]');
  if (added) {
    if (window.matchMedia("(min-width: 768px)").matches) {
      sidecartInput.checked = true;
    } else {
      location = this.querySelector(".fls-tocart__link")["href"];
    }
    added = false;
    submitButton.innerHTML =
      '<label for="add-to-cart">Add to cart</label><a class="fls-tocart__link hidden" href="{{ routes.cart_url }}"></a>';
  } else {
    if (!submitButton || submitButton.classList.contains("loading")) return;

    // this.handleErrorMessage();
    // this.cartNotification.setActiveElement(document.activeElement);

    submitButton.setAttribute("aria-disabled", true);
    submitButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="14" viewBox="0 0 22 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M21.3499 2.15437C21.7404 1.76385 21.7404 1.13068 21.3499 0.740159C20.9594 0.349635 20.3262 0.349635 19.9357 0.740159L7.78571 12.8901L2.06428 7.16869C1.67376 6.77817 1.0406 6.77817 0.650071 7.16869C0.259547 7.55922 0.259547 8.19238 0.650071 8.5829L7.07777 15.0106C7.07805 15.0109 7.07833 15.0112 7.0786 15.0114C7.12742 15.0603 7.18003 15.103 7.23548 15.1396C7.62363 15.3959 8.15111 15.3531 8.49282 15.0114C8.49309 15.0112 8.49337 15.0109 8.49365 15.0106L21.3499 2.15437Z" fill="#EFEBE7"/>
            </svg>`;
    // document.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    config.body = JSON.stringify({
      ...JSON.parse(serializeForm(document.getElementById("fls-cart"))),
      // sections: document.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          // document.handleErrorMessage(response.description);
          return;
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(async () => {
        submitButton.innerHTML = "view cart";
        submitButton.removeAttribute("aria-disabled");
        added = true;

        jQuery.getJSON("/cart.js", async (cart) => {
          const fullCart = await addCompareAtPrice(cart);
          pupulateCart(fullCart);
        });

        // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }
}

const addCompareAtPrice = async (cart) => {
  await cart.items.forEach((item) => {
    $.ajax({
      url: "/products/" + item.handle + ".js",
      dataType: "json",
      async: false,
      success: (product) => {
        const variant = product.variants.filter(
          (v) => v.id === item.variant_id
        );
        item["compare_at_price"] = variant.length
          ? variant[0].compare_at_price
          : 0;
      },
    });
  });

  return cart;
};
